import React, { useState, useEffect } from 'react';
import Modal from 'react-awesome-modal';
import Fuse from 'fuse.js';
import { getCompareData, linkTemplate, unlinkTemplate } from '../../../Services/IBS/IbsService';
import SelectSearch from 'react-select-search';
import IbsSurveyStore from '../../Stores/IbsSurveyStore';

function fuzzySearch(options) {
    const fuse = new Fuse(options, {
        keys: ['mandateId', 'agrId', 'asset', 'style', 'fundName', 'managerName', 'name', 'value'],
        threshold: 0.3
    });

    return (value) => {
        if (!value.length) {
            return options;
        }

        /* Don't bother with a fuzzy search, just return exact matches */
        return options.filter(option => option.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    };
}

export const LinkModal = ({ linkModalShow, setLinkModalShow, row, updateRow, isExisting = false }) => {
    let mappedOptions = [];
    let { templateLinkEntries } = IbsSurveyStore;

    if (templateLinkEntries?.length > 0) {
        mappedOptions = templateLinkEntries.map(linkEntry => ({
            ...linkEntry,
            name: [linkEntry.mandateId, linkEntry.agrId, linkEntry.asset, linkEntry.style, linkEntry?.fundName, linkEntry?.managerName].join(' | '),
            value: `${linkEntry.mandateId}`
        }))
    }

    const [selected, _setSelected] = useState((row && row.mandateId) ? row.mandateId : false);
    const [selectedManagerName, setSelectedManagerName] = useState(row?.managerName);
    const [selectedFundName, setSelectedFundName] = useState(row?.fundName);

    useEffect(() => {
        /* Pre-select value if row has a mandate id (i.e. row is guessed mandate) */
        if (`${selected}` !== `${row.mandateId}`) {
            _setSelected(`${row.mandateId}`);
        }
    }, [linkModalShow]);

    let handleChange = (e) => {
        let chosenEntry = templateLinkEntries.find(entry => `${entry.mandateId}` === e);
        setSelectedManagerName(chosenEntry?.managerName)
        setSelectedFundName(chosenEntry?.fundName)
        _setSelected(e);
    }

    let warningMessage = null;
    if ((selectedManagerName && row?.managerName !== selectedManagerName) || (selectedFundName && row?.fundName !== selectedFundName)) {
        warningMessage = true;
    }

    return (<Modal
        width="950"
        className="testClass"
        effect="fadeInDown"
        visible={linkModalShow}
    >
        <div className="commentModal linkModal" id="linkModal">
            <h3> <i className="fa fa-edit"></i> {isExisting ? "Compare" : "Link to existing" } Mandate</h3>
            <hr />
            <SelectSearch
                onChange={handleChange}
                value={selected}
                options={mappedOptions}
                search
                filterOptions={fuzzySearch}
                placeholder="Search..."

                renderOption={(optionsProps, optionData, optionSnapshot, className) => {
                    let name = optionData.name ? optionData.name : optionData.item.name;

                    let idxOfDelim = name.substring(0, name.lastIndexOf(' | ')).lastIndexOf(' | ');

                    let splitText = [name.substring(0, idxOfDelim), ...name.substring(idxOfDelim + 3).split(` | `)];

                    let text = splitText
                        .map((l, i) => (
                            <React.Fragment key={i}>{l}{i < (splitText.length - 1) ? <br /> : ''}</React.Fragment>
                        ));

                    return (<button {...optionsProps} type="button" className={className}>
                        {text}
                    </button>);
                }}
            />
            {warningMessage ? <div className='linkWarning'>
                Manager and fund names in the database "{selectedManagerName} - {selectedFundName}" are different from those on the template "{row?.managerName} - {row?.fundName}". Link anyway?
            </div> : null}
            <hr />
            <div className="linkModalButtons">
                {isExisting
                    ? <></>
                    : <button type="button" className="btn btn-close" disabled={isExisting} onClick={() => {
                        let chosenEntry = templateLinkEntries.find(entry => `${entry.mandateId}` === selected);
                        if (chosenEntry) {
                            let updatedRow = { ...row, mandateId: chosenEntry.mandateId };
                            linkTemplate(updatedRow.rowId, selected);
                            updateRow(updatedRow);
                            _setSelected(false);
                            setSelectedFundName(null);
                            setSelectedManagerName(null);
                        }
                        setLinkModalShow(false);
                        }}>Link</button>
                }
                <button type="button" className="btn btn-close orange" onClick={() => {
                    _setSelected(false);
                    setSelectedFundName(null);
                    setSelectedManagerName(null);
                    setLinkModalShow(false);
                }}>Cancel</button>
                {isExisting
                    ? <></>
                    : <button type="button" className="btn btn-close btn-left" disabled={row.mandateId <= 0} onClick={() => {
                        unlinkTemplate(row.rowId);
                        _setSelected(false);
                        setSelectedFundName(null);
                        setSelectedManagerName(null);
                        setLinkModalShow(false);
                    }}>Unlink</button>
                }
                <button type="button" className="btn btn-close btn-left" disabled={selected <= 0} onClick={async () => {
                    let tableHtml = await getCompareData(isExisting ? row.mandateRowId : row.rowId, selected, isExisting);

                    var win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=780");
                    win.document.body.innerHTML = tableHtml;
                }}>Compare</button>
            </div>
        </div>
    </Modal>)
}